import { type Common } from '../common.js';
import {
  type ToolTabConfigurableToolDefinition,
  type ToolTabConfigurableToolDefinitionCreateValues,
  type ToolTabConfigurableToolDefinitionFindAllOptions,
  type ToolTabConfigurableToolDefinitionFindOneOptions,
  type ToolTabConfigurableToolDefinitionUpdateValues,
  type ToolTabConfigurableToolDefinitionWithUsage,
} from '../models/assistant/toolDefinition/index.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/tool-definitions';
  }

  async findAll(
    options?: ToolTabConfigurableToolDefinitionFindAllOptions
  ): Promise<ToolTabConfigurableToolDefinitionWithUsage[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<ToolTabConfigurableToolDefinitionFindAllOptions>
  ): Promise<PaginationResponse<ToolTabConfigurableToolDefinitionWithUsage>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(
    id: string,
    options?: ToolTabConfigurableToolDefinitionFindOneOptions
  ): Promise<ToolTabConfigurableToolDefinitionWithUsage> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`, options);
    return await this.common.getJSON(url);
  }

  async create(
    values: ToolTabConfigurableToolDefinitionCreateValues
  ): Promise<ToolTabConfigurableToolDefinition> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: ToolTabConfigurableToolDefinitionUpdateValues
  ): Promise<ToolTabConfigurableToolDefinition> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async delete(id: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
